import styled from 'styled-components/macro'

export const StyledPaymentWrapper = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`

export const StyledPaymentContent = styled.article`
  max-width: 30rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const StyledIcon = styled.div`
  padding: 1.956rem;
  background-color: ${({ theme }) => theme.colors.RED_80};
  border-radius: 50%;
  width: 1.088rem;
  height: 1.088rem;
  margin-bottom: 1rem;

  svg path {
    fill: ${({ theme }) => theme.colors.RED_1000};
  }
`

export const StyledPaymentDescription = styled.div`
  margin-bottom: 1rem;
`
